import { IMultiStopLegDatObjects } from 'types/graphqlTypes'

export const getMilesTooltip = (multiStopLegDatObjects?: IMultiStopLegDatObjects[]) => {
  const tooltip = []

  if (multiStopLegDatObjects && multiStopLegDatObjects.length > 1) {
    tooltip.push('Distance measures according to the DAT.')

    multiStopLegDatObjects.forEach((stop, idx) => {
      if (idx === 0) {
        tooltip.push(`PU - Stop 1: ${stop.miles} mi`)
      } else if (idx + 1 === multiStopLegDatObjects.length) {
        tooltip.push(`Stop ${idx + 1} - DEL: ${stop.miles} mi`)
      } else {
        tooltip.push(`Stop ${idx} - Stop ${idx + 1}: ${stop.miles} mi`)
      }
    })
  }

  return tooltip
}
